/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Noble_Steep_Goat_ExhaleInputs */

const fr_noble_steep_goat_exhale = /** @type {(inputs: Noble_Steep_Goat_ExhaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors du chargement des cours.`)
};

/**

* @param {Noble_Steep_Goat_ExhaleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const noble_steep_goat_exhale = /** @type {((inputs?: Noble_Steep_Goat_ExhaleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Noble_Steep_Goat_ExhaleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_noble_steep_goat_exhale(inputs)
});